/*正则*/

/**
 * 根据正则或去指定字符串中匹配的 位置和 匹配的元素数组
 * [getIndex description]
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 */
RegExp.prototype.getIndex = function(str){
    var vArray = str.match(this);
    var indexArray = [];
    if(vArray !== null){
        for(var i = 0; i < vArray.length; i++){
            var vIndex = str.indexOf(vArray[i]);
            if(vIndex >= 0){
                indexArray.push(vIndex)
            }
        }
    }else{
        return [indexArray, vArray]
    }
    return [indexArray, vArray]
};

export let reg = {
    "^\d+$"                                                                                                                                   :'非负整数',
    "^[0-9]*[1-9][0-9]*$"                                                                                                                     :'正整数',
    "^((-\d+)|(0+))$"                                                                                                                         :'非正整数',
    "^-[0-9]*[1-9][0-9]*$"                                                                                                                    :'负整数',
    "^-?\d+$"                                                                                                                                 :'整数',
    "^\d+(\.\d+)?$"                                                                                                                           :'非负浮点数',
    "^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$"                                                         :'正浮点数',
    "^((-\d+(\.\d+)?)|(0+(\.0+)?))$"                                                                                                          :'非正浮点数',
    "^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$"                                                      :'负浮点数',
    "^(-?\d+)(\.\d+)?$"                                                                                                                       :'浮点数',
    "^\d+(\.{1}\d+)?$"                                                                                                                        :'数字',
    "^[A-Za-z]+$"                                                                                                                             :'由26个英文字母组成的字符串',
    "^[A-Z]+$"                                                                                                                                :'由26个英文字母的大写组成的字符串',
    "^[a-z]+$"                                                                                                                                :'由26个英文字母的小写组成的字符串',
    "[A-Za-z0-9]+$"                                                                                                                           :'由数字和26个英文字母组成的字符串',
    "^\w+$"                                                                                                                                   :'由数字、26个英文字母或者下划线组成的字符串',
    "^[\x00-\xff]+$"                                                                                                                          :'匹配所有 单 字节长度的字符组成的字符串',
    "^[^\x00-\xff]+$"                                                                                                                         :'匹配所有 双 字节长度的字符组成的字符串',
    "[^\x00-\xff]+"                                                                                                                           :'字符串是否含有双字节字',
    "^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$"                                                                                                   :'email地址1',
    "w+([-+.]w+)*@w+([-.]w+)*.w+([-.]w+)*"                                                                                                    :'email地址2',
    "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"                                                           :'email地址3',
    "^[a-zA-z]+://(\w+(-\w+)*)(\.(\w+(-\w+)*))*(\?\S*)?$"                                                                                     :'url地址1',
    "http://([w-]+.)+[w-]+(/[w- ./?%&=]*)?"                                                                                                   :'url地址2',
    "[u4e00-u9fa5]"                                                                                                                           :'匹配中文字符的正则',
    "[^x00-xff]"                                                                                                                              :'匹配双字节字符(包括汉字在内)',
    "n[s| ]*r"                                                                                                                                :'匹配空行的正则',
    "<(.*)>.*</1>|<(.*) />"                                                                                                                   :'匹配HTML标记的正则',
    "(^s*)|(s*$)"                                                                                                                             :'匹配首尾空格的正则',
    "^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$":'匹配IP地址的正则1',
    "(d+).(d+).(d+).(d+)"                                                                                                                     :'匹配IP地址的正则2',
}

export function RegExp_test(val, i) {
    let test = new RegExp(reg[i]).test(val);
    return test;
}

/*
限制表单文本框输入内容

只能输入中文：
     onkeyup="value=value.replace(/[^u4E00-u9FA5]/g,'')" 
         onbeforepaste="clipboardData.setData('text',
         clipboardData.getData('text').replace(/[^u4E00-u9FA5]/g,''))"

只能输入全角字符：
     onkeyup="value=value.replace(/[^uFF00-uFFFF]/g,'')" 
         onbeforepaste="clipboardData.setData('text',
         clipboardData.getData('text').replace(/[^uFF00-uFFFF]/g,''))"

只能输入数字：
     onkeyup="value=value.replace(/[^d]/g,'')" 
         onbeforepaste="clipboardData.setData('text',
         clipboardData.getData('text').replace(/[^d]/g,''))"

只能输入数字和英文：
     onkeyup="value=value.replace(/[W]/g,'')" 
         onbeforepaste="clipboardData.setData('text',
         clipboardData.getData('text').replace(/[^d]/g,''))"
*/

/*
整数或者小数：^[0-9]+\.{0,1}[0-9]{0,2}$
只能输入数字："^[0-9]*$"。
只能输入n位的数字："^\d{n}$"。
只能输入至少n位的数字："^\d{n,}$"。
只能输入m~n位的数字：。"^\d{m,n}$"
只能输入零和非零开头的数字："^(0|[1-9][0-9]*)$"。
只能输入有两位小数的正实数："^[0-9]+(.[0-9]{2})?$"。
只能输入有1~3位小数的正实数："^[0-9]+(.[0-9]{1,3})?$"。
只能输入非零的正整数："^\+?[1-9][0-9]*$"。
只能输入非零的负整数："^\-[1-9][]0-9"*$。
只能输入长度为3的字符："^.{3}$"。
只能输入由26个英文字母组成的字符串："^[A-Za-z]+$"。
只能输入由26个大写英文字母组成的字符串："^[A-Z]+$"。
只能输入由26个小写英文字母组成的字符串："^[a-z]+$"。
只能输入由数字和26个英文字母组成的字符串："^[A-Za-z0-9]+$"。
只能输入由数字、26个英文字母或者下划线组成的字符串："^\w+$"。
验证用户密码："^[a-zA-Z]\w{5,17}$"正确格式为：以字母开头，长度在6~18之间，只能包含字符、数字和下划线。
验证是否含有^%&'',;=?$\"等字符："[^%&'',;=?$\x22]+"。
只能输入汉字："^[\u4e00-\u9fa5]{0,}$"
验证Email地址："^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$"。
验证InternetURL："^http://([\w-]+\.)+[\w-]+(/[\w-./?%&=]*)?$"。
验证电话号码："^(\(\d{3,4}-)|\d{3.4}-)?\d{7,8}$"正确格式为："XXX-XXXXXXX"、"XXXX- XXXXXXXX"、"XXX-XXXXXXX"、"XXX-XXXXXXXX"、"XXXXXXX"和"XXXXXXXX"。
验证身份证号（15位或18位数字）："^\d{15}|\d{18}$"。
验证一年的12个月："^(0?[1-9]|1[0-2])$"正确格式为："01"～"09"和"1"～"12"。
验证一个月的31天："^((0?[1-9])|((1|2)[0-9])|30|31)$"正确格式为；"01"～"09"和"1"～"31"。整数或者小数：^[0-9]+\.{0,1}[0-9]{0,2}$
只能输入数字："^[0-9]*$"。
只能输入n位的数字："^\d{n}$"。
只能输入至少n位的数字："^\d{n,}$"。
只能输入m~n位的数字：。"^\d{m,n}$"
只能输入零和非零开头的数字："^(0|[1-9][0-9]*)$"。
只能输入有两位小数的正实数："^[0-9]+(.[0-9]{2})?$"。
只能输入有1~3位小数的正实数："^[0-9]+(.[0-9]{1,3})?$"。
只能输入非零的正整数："^\+?[1-9][0-9]*$"。
只能输入非零的负整数："^\-[1-9][]0-9"*$。
只能输入长度为3的字符："^.{3}$"。
只能输入由26个英文字母组成的字符串："^[A-Za-z]+$"。
只能输入由26个大写英文字母组成的字符串："^[A-Z]+$"。
只能输入由26个小写英文字母组成的字符串："^[a-z]+$"。
只能输入由数字和26个英文字母组成的字符串："^[A-Za-z0-9]+$"。
只能输入由数字、26个英文字母或者下划线组成的字符串："^\w+$"。
验证用户密码："^[a-zA-Z]\w{5,17}$"正确格式为：以字母开头，长度在6~18之间，只能包含字符、数字和下划线。
验证是否含有^%&'',;=?$\"等字符："[^%&'',;=?$\x22]+"。
只能输入汉字："^[\u4e00-\u9fa5]{0,}$"
验证Email地址："^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$"。
验证InternetURL："^http://([\w-]+\.)+[\w-]+(/[\w-./?%&=]*)?$"。
验证电话号码："^(\(\d{3,4}-)|\d{3.4}-)?\d{7,8}$"正确格式为："XXX-XXXXXXX"、"XXXX- XXXXXXXX"、"XXX-XXXXXXX"、"XXX-XXXXXXXX"、"XXXXXXX"和"XXXXXXXX"。
验证身份证号（15位或18位数字）："^\d{15}|\d{18}$"。
验证一年的12个月："^(0?[1-9]|1[0-2])$"正确格式为："01"～"09"和"1"～"12"。
验证一个月的31天："^((0?[1-9])|((1|2)[0-9])|30|31)$"正确格式为；"01"～"09"和"1"～"31"。

Phone : /^((\(\d{2,3}\))|(\d{3}\-))?(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(\-\d{1,4})?$/    
Mobile : /^((\(\d{2,3}\))|(\d{3}\-))?13\d{9}$/    
Url : /^http:\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/   
IdCard : /^\d{15}(\d{2}[A-Za-z0-9])?$/   
QQ : /^[1-9]\d{4,8}$/   
某种特殊金额：/^((\d{1,3}(,\d{3})*)|(\d+))(\.\d{2})?$/               //说明：除“XXX    XX,XXX    XX,XXX.00”格式外
 */


// WEBPACK FOOTER //
// ./src/assets/js-plug-in-unit/unit_RegExp.js